<template>
  <div class="case-confirm-dailog dialog col-block width-full">
    <template>
      <div class="main-container case col-block width-full">
        <div class="form-block col-block width-full">
          <customForm
            :init="caseData"
            :layoutType="'grid'"
            :groupCount="6"
            :forms="formOptions['field1']"
            :reading="true"
            :gap="'16px 4px'"
            :titleSmallInterval="true"
            @change="() => {}"
          ></customForm>
        </div>
      </div>
    </template>
    <template>
      <hr class="custom full" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
      <div class="main-container analysis col-block width-full">
        <div class="form-block col-block width-full">
          <customForm
            :init="analysisData"
            :layoutType="'grid'"
            :groupCount="6"
            :forms="formOptions['field2']"
            :reading="true"
            :gap="'16px 4px'"
            :titleSmallInterval="true"
            @change="() => {}"
          ></customForm>
        </div>
        <div class="form-block col-block width-full">
          <customForm
            :init="analysisData"
            :layoutType="'grid'"
            :groupCount="6"
            :forms="formOptions['field3']"
            :reading="true"
            :gap="'16px 4px'"
            :titleSmallInterval="true"
            @change="() => {}"
          >
            <template slot="INTRACTABLE_DISEASE" slot-scope="props">
              <div class="INTRACTABLE_DISEASE-container col-block flex-start" :name="props">
                <!-- <template v-if="analysisData.intractable_disease_panel || analysisData.designated_intractable_disease_panels">
                  <div v-html="(analysisData.intractable_disease_panels || []).concat(analysisData.designated_intractable_disease_panels || []).map(name => $t(intractableDiseaseValueMap[name].title)).join(' 、 ')"></div>
                </template> -->
                <template v-if="analysisData.intractable_disease_panel">
                  <div v-html="(analysisData.intractable_disease_panels || []).map(name => $t(intractableDiseaseValueMap[name].title)).join(' 、 ')"></div>
                </template>
                <div v-else>- -</div>
              </div>
            </template>
            <template slot="PHENOTYPE" slot-scope="props">
              <div class="PHENOTYPE-container col-block flex-start" :name="props">
                <template v-if="analysisData.phenotypes">
                  <template v-for="(key, kindex) in Object.keys(analysisData.phenotypes)">
                    <div v-for="(data, dindex) in analysisData.phenotypes[key]" :key="kindex + '_' + dindex">{{ data.query }}</div>
                  </template>
                </template>
                <div v-else>- -</div>
              </div>
            </template>
            <template slot="GENE_PANEL" slot-scope="props">
              <div class="GENE_PANEL-container col-block flex-start" :name="props">
                <template v-if="analysisData.gene_panels">
                  <div v-for="(data, dindex) in analysisData.gene_panels" :key="dindex">{{ data.name }}</div>
                </template>
                <div v-else>- -</div>
              </div>
            </template>
            <template slot="AFT" slot-scope="props">
              <div class="AFT-container col-block width-full" :name="props" :style="{ 'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr' }">
                <div
                  v-for="(option, oindex) in AFTOptions"
                  :key="oindex"
                  :style="{ 'grid-column': 'span ' + option.grid + ' / auto' }"
                >{{ option.title + (option.operator || ' =') + ' ' }}<span :style="(option.style || (() => ({})))(option.value(analysisData))">{{ (option.display || (x => x))(option.value(analysisData)) }}</span></div>
              </div>
            </template>
            <template slot="ST" slot-scope="props">
              <div class="ST-container col-block width-full" :name="props" :style="{ 'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr' }">
                <div
                  v-for="(option, oindex) in STOptions"
                  :key="oindex"
                  :style="{ 'grid-column': 'span ' + option.grid + ' / auto' }"
                >{{ option.title + (option.operator || ' =') + ' ' }}<span :style="(option.style || (() => ({})))(option.value(analysisData))">{{ (option.display || (x => x))(option.value(analysisData)) }}</span></div>
              </div>
            </template>
          </customForm>
        </div>
      </div>
    </template>
    <template v-if="fileSets.length || caseData.omics_name">
      <hr class="custom full" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
      <div class="main-container file col-block width-full">
        <div class="main-title">{{ $t('DIALOG.caseConfirm.___datasetTitle', { type: { 'vcf': 'VCF', 'fastq': 'FASTQ' }[caseData.dataset] }) }}</div>
        <div class="file-field row-block" :style="{ 'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr' }">
          <div v-if="caseData.dataset === 'fastq'" class="pipeline-container col-block" :style="{ 'grid-column': 'span 2 / auto' }">
            <div class="main-title">{{ $t('DIALOG.caseConfirm.___pipelineTitle') }}</div>
            <div :style="{ height: '8px' }"></div>
            <div v-html="[caseData.omics_name, caseData.pipeline_name, caseData.library_type_name].filter(x => x).join(',<br>')"></div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="set-container col-block" :style="{ 'grid-column': 'span ' + ({ vcf: '6', fastq: '4' }[caseData.dataset]) + ' / auto' }">
            <div class="set-block row-block" v-for="(set, index) in fileSets" :key="index">
              <template v-if="caseData.dataset === 'vcf'">
                <div v-if="set.snv" class="file-block" :style="{ flex: 1 }">
                  <div class="file-title">{{ $t('DIALOG.caseConfirm.___snvVcfTitle') }}</div>
                  <div :style="{ height: '5px' }"></div>
                  <div class="file-source ellipsis">{{ set.snv.name }}</div>
                </div>
                <div v-if="set.sv" class="file-block" :style="{ flex: 1 }">
                  <div class="file-title">{{ $t('DIALOG.caseConfirm.___svVcfTitle') }}</div>
                  <div :style="{ height: '5px' }"></div>
                  <div class="file-source-block col-block flex-start">
                    <div class="file-source ellipsis" v-for="(file, findex) in set.sv" :key="findex">{{ file.name }}</div>
                  </div>
                </div>
                <div v-if="set.str" class="file-block" :style="{ flex: 1 }">
                  <div class="file-title">{{ $t('DIALOG.caseConfirm.___strVcfTitle') }}</div>
                  <div :style="{ height: '5px' }"></div>
                  <div class="file-source ellipsis">{{ set.str.name }}</div>
                </div>
              </template>
              <template v-if="caseData.dataset === 'fastq'">
                <div class="file-block" :style="{ flex: 1 }">
                  <div class="file-title">{{ $t('DIALOG.caseConfirm.___fastqTitle', { set: (index + 1), read: 'R1' }) }}</div>
                  <div :style="{ height: '5px' }"></div>
                  <div class="file-source ellipsis">{{ set.r1.name }}</div>
                </div>
                <template v-if="caseData.pipelineType === 'paired'">
                  <div :style="{ width: '16px' }"></div>
                  <div class="file-block" :style="{ flex: 1 }">
                    <div class="file-title">{{ $t('DIALOG.caseConfirm.___fastqTitle', { set: (index + 1), read: 'R2' }) }}</div>
                    <div :style="{ height: '5px' }"></div>
                    <div class="file-source ellipsis">{{ set.r2.name }}</div>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" @click="e => checkAlerts()">
        <span>{{ $t('COMMON.button.___create') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import customForm from '../../components/tool/customForm'
import { intractableDiseaseOptions } from '../../constants/global/data'
import { _LOCAL_BUILD } from '../../constants/global/config'

export default {
  components: {
    customForm
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    caseData () {
      return this.param.caseData
    },
    analysisData () {
      return this.caseData.project
    },
    fileSets () {
      return this.param.fileSets
    },
    intractableDiseaseValueMap () {
      return intractableDiseaseOptions.reduce((map, option) => ({ ...map, [option.value]: option }), {})
    },
    // static
    formOptions () {
      return {
        'field1': [
          // 1
          {
            title: this.$t('DIALOG.caseConfirm.form.case.title.___caseID'),
            value: 'case_id',
            type: 'text',
            wrap: true,
            grid: 2
          },
          {
            title: this.$t('DIALOG.caseConfirm.form.case.title.___affected'),
            value: 'affected',
            type: 'text',
            wrap: true,
            grid: 1,
            style: {
              'true': { color: '#83C91E' },
              'false': { color: '#999999' }
            }[this.caseData.affected + ''],
            inputFormat: value => ({
              'true': this.$t('DIALOG.caseConfirm.form.case.format.affected.___true'),
              'false': this.$t('DIALOG.caseConfirm.form.case.format.affected.___false')
            }[value + ''])
          },
          {
            title: this.$t('DIALOG.caseConfirm.form.case.title.___subjectName'),
            value: 'subject_name',
            type: 'text',
            wrap: true,
            grid: 1
          },
          {
            title: this.$t('DIALOG.caseConfirm.form.case.title.___sex'),
            value: 'sex',
            type: 'text',
            wrap: true,
            grid: 1,
            style: {
              Male: { color: '#003679' },
              Female: { color: '#FA3D3D' },
              Unknown: { color: '#333333' }
            }[this.caseData.sex],
            inputFormat: value => ({
              Male: this.$t('DIALOG.caseConfirm.form.case.format.sex.___male'),
              Female: this.$t('DIALOG.caseConfirm.form.case.format.sex.___female'),
              Unknown: this.$t('DIALOG.caseConfirm.form.case.format.sex.___unknown')
            }[value])
          },
          {
            title: this.$t('DIALOG.caseConfirm.form.case.title.___birthYear'),
            value: 'birth_year',
            type: 'text',
            wrap: true,
            grid: 1,
            inputFormat: value => value || this.$t('DIALOG.caseConfirm.form.case.format.birthYear.___empty')
          },
          // 2
          {
            title: this.$t('DIALOG.caseConfirm.form.case.title.___population'),
            value: 'population',
            type: 'text',
            wrap: true,
            grid: 2,
            inputFormat: value => value || '--'
          },
          {
            title: this.$t('DIALOG.caseConfirm.form.case.title.___note'),
            value: 'note',
            type: 'text',
            wrap: true,
            grid: 4,
            inputFormat: value => value || '--'
          }
        ],
        'field2': _LOCAL_BUILD ? [
          {
            title: this.$t('DIALOG.caseConfirm.form.analysis.title.___name'),
            value: 'name',
            type: 'text',
            wrap: true,
            grid: 2
          },
          {
            title: this.$t('DIALOG.caseConfirm.form.analysis.title.___note'),
            value: 'note',
            type: 'text',
            wrap: true,
            grid: 4,
            inputFormat: value => value || '--'
          }
        ] : [
          {
            title: this.$t('DIALOG.caseConfirm.form.analysis.title.___name'),
            value: 'name',
            type: 'text',
            wrap: true,
            grid: 2
          },
          {
            title: this.$t('DIALOG.caseConfirm.form.analysis.title.___note'),
            value: 'note',
            type: 'text',
            wrap: true,
            grid: 3,
            inputFormat: value => value || '--'
          },
          {
            title: this.$t('DIALOG.caseConfirm.form.analysis.title.___reportPhenovardb'),
            value: 'report_phenovardb',
            type: 'text',
            wrap: true,
            grid: 1,
            style: {
              'true': { color: '#83C91E' },
              'false': { color: '#999999' }
            }[this.analysisData.report_phenovardb + ''],
            inputFormat: value => ({
              'true': this.$t('DIALOG.caseConfirm.form.analysis.format.reportPhenovardb.___true'),
              'false': this.$t('DIALOG.caseConfirm.form.analysis.format.reportPhenovardb.___false')
            }[value + ''])
          }
        ],
        'field3': [
          // 1
          ...(!_LOCAL_BUILD && (this.$i18n.locale === 'ja') ? [
            {
              title: this.$t('DIALOG.caseConfirm.form.analysis.title.___intractableDisease'),
              value: 'INTRACTABLE_DISEASE',
              type: 'custom',
              wrap: true,
              grid: 5
            },
            {
              title: this.$t('DIALOG.caseConfirm.form.analysis.title.___intractableDiseaseTag'),
              value: 'intractable_disease_tag',
              type: 'text',
              wrap: true,
              grid: 1,
              style: {
                'true': { color: '#83C91E' },
                'false': { color: '#999999' }
              }[this.analysisData.intractable_disease_tag + ''],
              inputFormat: value => ({
                'true': this.$t('DIALOG.caseConfirm.form.analysis.format.intractableDiseaseTag.___true'),
                'false': this.$t('DIALOG.caseConfirm.form.analysis.format.intractableDiseaseTag.___false')
              }[value + ''])
            }
          ] : []),
          {
            title: this.$t('DIALOG.caseConfirm.form.analysis.title.___phenotype'),
            value: 'PHENOTYPE',
            type: 'custom',
            wrap: true,
            grid: 3
          },
          {
            title: this.$t('DIALOG.caseConfirm.form.analysis.title.___genePanel'),
            value: 'GENE_PANEL',
            type: 'custom',
            grid: 3
          },
          // 2
          {
            title: this.$t('DIALOG.caseConfirm.form.analysis.title.___aft'),
            value: 'AFT',
            type: 'custom',
            grid: 6
          },
          // 3
          {
            title: this.$t('DIALOG.caseConfirm.form.analysis.title.___st'),
            value: 'ST',
            type: 'custom',
            grid: 6
          }
        ]
      }
    },
    AFTOptions () {
      return [
        // 1
        {
          title: this.$t('DIALOG.caseConfirm.form.analysis.aft.title.___ad_cutoff'),
          value: data => data.ad_cutoff,
          grid: 1
        },
        {
          title: this.$t('DIALOG.caseConfirm.form.analysis.aft.title.___ar_cutoff'),
          value: data => data.ar_cutoff,
          grid: 1
        },
        {
          title: this.$t('DIALOG.caseConfirm.form.analysis.aft.title.___exclude_low_quality_variants'),
          value: data => data.exclude_low_quality_variants,
          grid: 4,
          style: value => ({
            'true': { color: '#006ED6' },
            'false': { color: '#999999' }
          }[value + '']),
          display: value => ({
            'true': this.$t('DIALOG.caseConfirm.form.analysis.aft.display.exclude_low_quality_variants.___true'),
            'false': this.$t('DIALOG.caseConfirm.form.analysis.aft.display.exclude_low_quality_variants.___false')
          }[value + ''])
        },
        // 2
        {
          title: this.$t('DIALOG.caseConfirm.form.analysis.aft.title.___comp_het_cutoff'),
          value: data => data.comp_het_cutoff,
          grid: 2
        },
        {
          title: this.$t('DIALOG.caseConfirm.form.analysis.aft.title.___enable_clinvar_benign_filter'),
          value: data => data.enable_clinvar_benign_filter,
          grid: 4,
          style: value => ({
            'true': { color: '#006ED6' },
            'false': { color: '#999999' }
          }[value + '']),
          display: value => ({
            'true': this.$t('DIALOG.caseConfirm.form.analysis.aft.display.enable_clinvar_benign_filter.___true'),
            'false': this.$t('DIALOG.caseConfirm.form.analysis.aft.display.enable_clinvar_benign_filter.___false')
          }[value + ''])
        }
      ]
    },
    STOptions () {
      return [
        {
          title: this.$t('DIALOG.caseConfirm.form.analysis.st.title.phenotype_score_cutoff'),
          value: data => data.phenotype_score_cutoff,
          grid: 2
        },
        {
          title: this.$t('DIALOG.caseConfirm.form.analysis.st.title.variant_score_cutoff'),
          value: data => data.variant_score_cutoff,
          grid: 2
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'setModal2Action'
    ]),
    async checkAlerts () {
      if (['Unknown'].includes(this.caseData.sex)) {
        if (!(await this.unknownSexAlert())) return
      }
      this.$emit('changeModal', {}, true)
    },
    async unknownSexAlert () {
      return new Promise(resolve => {
        this.setModal2Action({
          action: 'toast',
          width: '496px',
          customStyles: {
            padding: 0,
            border: 0
          },
          param: {
            type: 'alert',
            content: this.$t('DIALOG.caseConfirm.modal.content.___unknownSexAlert'),
            buttons: [
              {
                title: this.$t('COMMON.button.___cancel'),
                type: 'gray',
                result: false
              },
              {
                title: this.$t('COMMON.button.___create'),
                type: 'alert',
                result: true
              }
            ]
          },
          callback: async result => {
            resolve(result)
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseConfirm.vue